"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_PAYMENT_RESPONSE_EXAMPLE = void 0;
const financial_common_response_1 = require("./financial-common.response");
exports.CREATE_PAYMENT_RESPONSE_EXAMPLE = {
    payment: financial_common_response_1.FIN_PAYMENT_RESPONSE_EXAMPLE,
    notificationSent: false,
};
//# sourceMappingURL=financial-payment.response.js.map